import React, { InputHTMLAttributes, useMemo } from 'react';

import { DefaultProps, FormatProps } from './types';
import { useField } from './useField';

type SelectProps = DefaultProps &
    FormatProps & {
        options?: { value: string | number; label: string; selected?: boolean }[];
    };

const EMPTY_ARR = [];

export const RxSelect: React.FC<React.PropsWithChildren<SelectProps & InputHTMLAttributes<unknown>>> = React.memo(
    (props) => {
        const { options = EMPTY_ARR, ...without } = props;
        const { rest, onInputChange, onInputBlur, ref } = useField(without);
        const inner = useMemo(() => {
            if (Array.isArray(options)) {
                return options.map((opt) => {
                    return (
                        <option value={opt.value} key={opt.value}>
                            {opt.label}
                        </option>
                    );
                });
            }
            return null;
        }, [options]);
        return (
            <select {...rest} ref={ref as any} name={props.field} onChange={onInputChange} onBlur={onInputBlur}>
                {inner}
                {props.children}
            </select>
        );
    },
);

export const Select = RxSelect;
